import { applyBrowserEntry } from 'shared/utils/apply-browser-entry';

// Imported first by index.tsx: createBrowserRouter reads the url as soon as ./app is evaluated.
applyBrowserEntry(window.location, window.history);
